// ─── src/hooks/useStats.ts ────────────────────────────────────────────────────

import { useQuery } from "@tanstack/react-query";
import { getRegistrationStats, getMentorStats } from "../api/stats";

export const statsKeys = {
  registrations: (city?: string) =>
    ["stats", "registrations", city ?? "all"] as const,
  mentors: () => ["stats", "mentors"] as const,
};

export const useRegistrationStats = (city?: string) =>
  useQuery({
    queryKey: statsKeys.registrations(city),
    queryFn:  () => getRegistrationStats(city),
    staleTime: 60_000, // 1 minute — aggregated counts change slowly
  });

export const useMentorStats = () =>
  useQuery({
    queryKey: statsKeys.mentors(),
    queryFn:  getMentorStats,
    staleTime: 60_000,
  });
